/**
 * Design system drop shadows
 * https://www.figma.com/file/HiRy7sEleqQg5xzfP7A263/Interne-brukerflater---KLADD-Designsystem?node-id=420%3A416
 */

export const dropShadows = {
  elevation1: "0 1px 5px rgba(0, 0, 0, 0.2)",
  elevation2: "0px 2px 8px rgba(0, 0, 0, 0.25)",
};
